<template>
  <div>
    <popup-edit-terminal ref="popupEditTerminal" />
    <div class="flex justify-between p-3">
      <p>Terminals are POS terminals used to register purchases.</p>
      <div class="flex justify-end">
        <vs-button
          icon="add"
          @click="$refs.popupEditTerminal.show()"
          type="relief"
          color="primary"
          class="mr-3"
          >Add terminal</vs-button
        >
      </div>
    </div>
    <vs-row class="mt-4">
      <vs-col
        class="rolecard p-3"
        v-for="terminal in terminals"
        :key="terminal.id"
      >
        <vs-card>
          <div slot="header">
            <vs-row vs-justify="space-between">
              <h6>{{ terminal.name }}</h6>
              <div>
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click="editTerminal(terminal)"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-4"
                  @click="confirmDelete(terminal)"
                />
              </div>
            </vs-row>
          </div>
          <div>
            <vs-row class="mt-4">
              <vs-col vs-w="4">ID</vs-col>
              <vs-col vs-w="8"
                ><i>{{ terminal.id }}</i></vs-col
              >
            </vs-row>
            <vs-row class="mt-4">
              <vs-col vs-w="4">Name</vs-col>
              <vs-col vs-w="8"
                ><i>{{ terminal.name }}</i></vs-col
              >
            </vs-row>
            <vs-row class="mt-4">
              <vs-col vs-w="4">Location</vs-col>
              <vs-col vs-w="8"
                ><i
                  ><code>{{
                    terminal.locationId
                      ? locationName(terminal.locationId.id)
                      : "No"
                  }}</code></i
                ></vs-col
              >
            </vs-row>
            <vs-row class="mt-4">
              <vs-col vs-w="4">Uses tips</vs-col>
              <vs-col vs-w="8"
                ><i
                  ><code>{{ terminal.mustRequestTip | yesno }}</code></i
                ></vs-col
              >
            </vs-row>
          </div>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import PopupEditTerminal from "./PopupEditTerminal.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    PopupEditTerminal,
  },
  data() {
    return {
      removeId: "",
    };
  },
  methods: {
    async confirmDelete(tr) {
      this.removeId = tr.id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this terminal?",
        accept: this.remove,
      });
    },
    async remove() {
      this.$vs.loading();
      await this.$store.dispatch("pos/venues/deleteTerminal", {
        venueId: this.venue.id,
        terminalId: this.removeId,
      });
      this.$vs.loading.close();
    },
    async editTerminal(terminal) {
      this.$refs.popupEditTerminal.show(terminal);
    },
  },
  computed: {
    ...mapGetters({
      venue: "pos/venues/venue",
      terminals: "pos/venues/terminals",
    }),
    locationName() {
      return (id) => {
        const location = this.venue.locations.find(
          (s) => s.locationId.id === id
        );
        return location ? location.name : "No";
      };
    },
  },

  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("pos/venues/getTerminals", this.venue.id);
    this.$vs.loading.close();
  },
};
</script>


<style lang="scss" scoped>
.role-table {
  max-height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.rolecard {
  &.deactivated {
    opacity: 0.75;
  }

  min-width: 380px;
  max-width: 380px;

  .con-vs-card {
    border: 2px solid #ccc;
  }

  .vs-card--content {
    margin-bottom: 0;
  }

  .vs-card--footer {
    padding: 6px 12px;
    margin-top: 0;
    transform: none;
    background-color: #ccc;
    font-size: 0.8rem;
  }
}
</style>